import React from 'react';

const GuidePage: React.FC = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>도우미</h1>
      <p>유튜브 영상이나 글을 통해 가이드를 작성하는 페이지입니다.</p>
      <p>추후 구현 예정입니다.</p>
    </div>
  );
};

export default GuidePage;